// extracted by mini-css-extract-plugin
export var drawerPaper = "_1q-0";
export var itemImage = "_1q-1";